import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import negate from 'lodash/negate';

export const hasValue = negate(isEmpty);

export const isSet = negate(isNil);

export const parseBoolean = (value) => {
  return isString(value) ? value === 'true' : Boolean(value);
};

export const parseNilOrValue = (value) => {
  if (isString(value)) {
    if (value === 'undefined') {
      return undefined;
    }

    if (value === 'null') {
      return null;
    }

    return value;
  }

  return value;
};
